import React from 'react';
import styled from '@emotion/styled';
import { Link } from "react-router-dom";

import ActivityList from '../Activity/ActivityList';
import AddActivity from '../Activity/AddActivity';

import { getCurrentDate } from '../helpers/helpers';
import { slugify } from '../helpers/helpers';

const Title = styled.input`
  background-color: transparent;
  border-top: 0;
  border-right: 0;
  border-bottom: 2px solid ${props => props.theme.colors.dark};
  border-left: 0;
  font-weight: 700;
  font-size: ${props => props.theme.size.large};
  min-height: 80px;
  padding-right: ${props => props.theme.size.small};
  padding-left: 50px;
  text-transform: uppercase;
  width: 100%;
  z-index: 1;

  &::placeholder {
    color: ${props => props.theme.colors.darkTransparent};
  }

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.xlarge};
    min-height: 100px;
    padding-right: 120px;
    padding-left: 50px;
  }
`;

const CurrentDate = styled.p`
  color: ${props => props.theme.colors.dark};
  font-size: ${props => props.theme.size.small};
  font-weight: 500;
  position: absolute;
  top: ${props => props.theme.size.xsmall};
  right: ${props => props.theme.size.xsmall};

  ${props => props.theme.breakpoint.tablet} {
    font-size: ${props => props.theme.size.large};
    top: ${props => props.theme.size.large};
    right: ${props => props.theme.size.large};
  }
`;

const Container = styled.div`
  border: 2px solid ${props => props.theme.colors.dark};
  margin: ${props => props.theme.size.medium} auto;
  max-width: calc(100% -  ${props => props.theme.size.xlarge});
  outline: 0;
  position: relative;
  width: 1000px;
`;

const Back = styled.div`
  position: absolute;
  height: 80px;
  width: 50px;

  ${props => props.theme.breakpoint.tablet} {
    height: 100px;
  }

  &::after {
    content: "";
    border-top: 2px solid ${props => props.theme.colors.dark};
    border-left: 2px solid ${props => props.theme.colors.dark};
    height: 18px;
    position: absolute;
    top: 30px;
    left: 25px;
    transform: rotate(-45deg);
    width: 18px;
    z-index: 2;

    ${props => props.theme.breakpoint.tablet} {
      border-top: 3px solid ${props => props.theme.colors.dark};
      border-left: 3px solid ${props => props.theme.colors.dark};
      top: 40px;
    }
  }
`

class Planner extends React.Component {
  constructor(props) {
    super(props);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.activityIndex = this.props.activities.findIndex( activity => {
      return slugify(activity.title) === this.props.match.params.id
    })
    this.activity = this.props.activities[this.activityIndex];
  }

  componentDidMount() {
    document.title = "LAP - " + this.activity.title;
  }

  onChangeTitle(event) {
    this.props.onChangeTitle(event, this.activityIndex);
  }

  render() {
    return (
      <Container>
        <Link to="/"><Back></Back></Link>
        <Title
          type="text"
          placeholder="what do you want to keep track off?"
          value={this.activity.title}
          onChange={this.onChangeTitle}
        />
        <CurrentDate>{getCurrentDate()}</CurrentDate>
        <ActivityList
          activityIndex={this.activityIndex}
          activities={this.activity.activities}
          addTimelineEntry={this.props.addTimelineEntry}
          removeActivity={this.props.removeActivity}
          removeLastEntry={this.props.removeLastEntry}
        />
        <AddActivity
          activityIndex={this.activityIndex}
          addActivity={this.props.addActivity}
        />
      </Container>
    );
  }
}

export default Planner;
